export default __webpack_public_path__ + "images/1f18efb8a2ae7936e36d466d2e4d665a.png";